import { render, staticRenderFns } from "./fullscreen-loading.component.vue?vue&type=template&id=4d20851d&"
import script from "./fullscreen-loading.component.vue?vue&type=script&lang=ts&"
export * from "./fullscreen-loading.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports